import { render } from "./TagsPage.vue?vue&type=template&id=0e4c7d62"
import script from "./TagsPage.vue?vue&type=script&lang=js"
export * from "./TagsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__